export default __webpack_public_path__ + "static/media/interative.f8649283.PNG";